export enum ConfigKeyTypes {
    String = 'STRING', 
    Integer = 'INTEGER', 
    Boolean = 'BOOLEAN', 
    Duration = 'DURATION'
}